import { Input, Output, EventEmitter, Directive } from '@angular/core';
import { IPostType } from 'projects/models/src/public-api';


@Directive()
export abstract class NgPostTypeComponent<T extends IPostType> {

  @Input() data: T;
  @Output() selected = new EventEmitter<T>();

  public select(x: T) {
    this.selected.emit(x);
  }

}
